import { LexicalCommand, createCommand } from 'lexical';

const OPEN_LINK_EDITOR_COMMAND: LexicalCommand<string> = createCommand();

export default OPEN_LINK_EDITOR_COMMAND;
